import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Store } from 'src/common/models';

@Component({
  selector: 'app-store-address',
  imports: [],
  templateUrl: './store-address.component.html',
  styleUrl: './store-address.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreAddressComponent {
  store = input<Store|undefined>()
}
